import styled from "styled-components";
import { COLORS, FONTS, HELPERS } from "../../../shared";
import { MEDIA_QUERY } from "../../../entities/Common";
import { VIEW_TYPE } from "../../../entities/Filter";

export const CondimentCardStyled = styled.div<{$colorSelected?:string}>`
  position: relative;
  width: 100%;
  cursor: pointer;
  border-radius: 3px;
  overflow: hidden;
  &.selected {
    .condiment-card__right {
      border-color: ${({ $colorSelected }) => ($colorSelected ||COLORS.GREEN)};
      background-color: ${({ $colorSelected }) => ($colorSelected ||COLORS.GREEN)};
    }
    .condiment-card__name {
      color: ${COLORS.WHITE};
    }
    .condiment-card__more {
      .condiment-btn {
        background: ${COLORS.WHITE};
        border-color: ${COLORS.WHITE};
        &:hover {
          transform: scale(1.01);
        }
        span {
          color: ${COLORS.PRIMARY_DARK};
        }
      }
    }

    .condiment-card__image img {
      transform: scale(1.15);
    }
  }
  .condiment-card {
    &__left {
      position: relative;
      width: 100%;
      height: 180px;
    }
    &__image {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      overflow: hidden;
      top: 0;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: ${HELPERS.TRANSITION};
      }
    }

    &__right {
      border: 2px solid ${COLORS.GRAY};
      border-top: none;
      transition: ${HELPERS.TRANSITION};
      padding: 5px;
      box-sizing: border-box;
    }
    &__select {
      position: absolute;
      right: 5px;
      top: 5px;
      z-index: 5;
      input {
        width: 20px;
        height: 20px;
        cursor: pointer;
        outline: none;
      }
    }
    &__more {
      position: static;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &__name {
      width: 100%;
      padding: 12px 7.5px;
      transition: ${HELPERS.TRANSITION};
      box-sizing: border-box;
      font: normal normal normal 16px/18px Arial;
      color: ${COLORS.PRIMARY_DARK};
      text-align: center;
    }
    &__description {
      display: none;
    }
  }

  &[data-hide="true"] {
    display: none;
  }

  &.view-${VIEW_TYPE.LIST} {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    height: auto;
    overflow: unset;
    &.selected {
      .condiment-card {
        &__right {
          width: calc(100% - 260px);
          padding: 10px;
          padding-left: 20px;
          padding-right: 20px;
          background-color: ${COLORS.GREEN};
          box-sizing: border-box;
          color: ${COLORS.WHITE};
        }
      }
    }
    .condiment-card {
      &__image {
        width: 100%;
        min-height: 180px;
        height: 100%;
        position: relative;
      }
      &__select {
        top: 5px;
        left: 235px;
      }
      &__left {
        width: 260px;
        height: inherit;
      }
      &__right {
        width: calc(100% - 280px);
        border: none;
        padding: 0;
        box-sizing: border-box;
      }
      &__description {
        display: block;
        transition: ${HELPERS.TRANSITION};
        margin-bottom: 20px;
      }
      &__more {
        transition: none;
        display: block;
        .full-btn {
          width: 200px;
        }
      }
      &__name {
        position: relative;
        color: inherit;
        padding: 0;
        margin-bottom: 10px;
        text-align: left;
        font-size: 18px;
        font-weight: ${FONTS.FONT_WEIGHT_BOLD};
      }
      &__more {
        position: relative;
        left: auto;
        top: auto;
        right: auto;
        bottom: auto;
        z-index: 5;
        opacity: 1;
        transform: none;
        visibility: visible;
        pointer-events: all;
      }
    }
  }

  @media (max-width: ${MEDIA_QUERY.TABLET_HORIZONTAL}) {
    &.view-${VIEW_TYPE.LIST} {
      &.condiment-category {
        flex-wrap: wrap;
        .condiment-card {
          &__left,
          &__right {
            width: 100%;
          }
          &__image {
            margin-bottom: 20px;
          }
          &__select {
            left: auto;
            right: 5px;
          }
        }
      }
    }
  }

  @media (max-width: ${MEDIA_QUERY.TABLET_VERTICAL}) {
    &.view-${VIEW_TYPE.LIST} {
      flex-wrap: wrap;
      .condiment-card {
        &__left,
        &__right {
          width: 100%;
        }
        &__image {
          margin-bottom: 20px;
        }
        &__select {
          left: auto;
          right: 5px;
        }
      }
    }
  }
  @media (max-width: ${MEDIA_QUERY.MOBILE}) {
    .condiment-card {
      &__left {
        height: 150px;
      }
      &__name {
        font: normal normal normal 14px/16px Arial;
      }
    }

    &.view-${VIEW_TYPE.LIST} {
      .condiment-card {
        &__name {
          font-size: 14px;
          margin-top: 10px;
        }
        &__description {
          font-size: 14px;
          margin-bottom: 10px;
        }
      }
    }
  }
`;
